var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/Neck/Position/Fret/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import pt from 'prop-types';
import { isNil } from 'ramda';
import { withTheme } from 'styled-components';
import { locShape, noteSelectionShape, locSelectionShape } from './../../../../../lib/shapes';
import { selectedNote, selectedLoc, decideContent, decideColor } from './../../../../../lib/fret';
import { fretWrapper } from './../../../../../components/Fretboard/Skins/skins';
import Content from './Content';
import Wrapper from './Wrapper';
/* eslint-disable react/prefer-stateless-function */

export class Fret extends React.Component {
  render() {
    const {
      note,
      loc,
      notes_on_fret,
      theme
    } = this.props;
    const {
      skinType,
      noteType,
      showNotes,
      showSelectionLabels,
      highlightOctaves,
      highlightSelections,
      showEnharmonics,
      selectedNotes,
      selectedLocations,
      clickAction,
      clickOffAction,
      touchMoveAction,
      selectedStrings,
      fretHighlight,
      fretHighlightColor
    } = this.context;
    const noteSelection = selectedNote(note, selectedNotes);
    const locSelection = selectedLoc(loc, selectedLocations);
    const selection = noteSelection || locSelection;
    const content = decideContent(showSelectionLabels, selection, showNotes, note);
    const color = decideColor(selection, theme, highlightOctaves, highlightSelections, note);
    const isHighlighted = !isNil(color);
    const SkinWrapper = fretWrapper(skinType);
    const isClickable = !isNil(clickAction);
    const onClickAction = isClickable ? () => clickAction({
      note,
      loc,
      notes_on_fret
    }) : undefined;
    const isOffClickable = !isNil(clickOffAction);
    const onClickOffAction = isOffClickable ? () => clickOffAction({
      note,
      loc,
      notes_on_fret
    }) : undefined;
    const isTouchMovable = !isNil(touchMoveAction);
    const onTouchMoveAction = isTouchMovable ? () => touchMoveAction({
      note,
      loc,
      notes_on_fret
    }) : undefined;
    return /*#__PURE__*/React.createElement(Wrapper, {
      isClickable: isClickable,
      onPointerDown: onClickAction,
      isOffClickable: isOffClickable,
      onPointerUp: onClickOffAction,
      onTouchMove: onTouchMoveAction,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(SkinWrapper, _extends({
      isHighlighted,
      color
    }, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 9
      }
    }), content && /*#__PURE__*/React.createElement(Content, _extends({
      content,
      noteType,
      showEnharmonics
    }, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 13
      }
    }))));
  }

}
Fret.propTypes = {
  note: pt.string.isRequired,
  loc: locShape.isRequired,
  notes_on_fret: pt.arrayOf(pt.string),
  theme: pt.shape({}).isRequired
};
Fret.contextTypes = {
  skinType: pt.string.isRequired,
  noteType: pt.string.isRequired,
  showNotes: pt.bool.isRequired,
  showSelectionLabels: pt.bool.isRequired,
  highlightOctaves: pt.bool.isRequired,
  highlightSelections: pt.bool.isRequired,
  showEnharmonics: pt.bool.isRequired,
  selectedNotes: pt.arrayOf(noteSelectionShape).isRequired,
  selectedLocations: pt.arrayOf(locSelectionShape).isRequired,
  clickAction: pt.func,
  clickOffAction: pt.func,
  touchMoveAction: pt.func,
  selectedStrings: pt.arrayOf(pt.string).isRequired,
  fretHighlight: pt.arrayOf(pt.number).isRequired,
  fretHighlightColor: pt.string.isRequired
};
export default withTheme(Fret);
